import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subject} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {BusinessProcessService} from '../../../../services/business-process.service';
import {DesignChangeLogAction} from '../../../../Models/designChangeLogAction';
import {Utils} from '../../../../services/utils';
import {DesignElementType} from '../../../../Models/enum/designElementType';
import {take} from 'rxjs/operators';
import {AdminService} from '../../../../services/admin.service';
import {GenericModalService} from '../../../../services/generic-modal.service';
import {error} from 'selenium-webdriver';
import {DateTimeService} from '../../../../services/date-time.service';

@Component({
  selector: 'app-consolidation-modal',
  templateUrl: './consolidation-modal.component.html',
  styleUrls: ['./consolidation-modal.component.css', '../../../../styles/modals.css']
})
export class ConsolidationModalComponent implements OnInit {

  @Input() modalTitle: string;
  utilsFunction = Utils;

  itemSaved: Subject<boolean>;
  objId: number;
  objMessage: string;
  submitClick = false;

  consolidationForm: FormGroup;
  consolidationEntries: DesignChangeLogAction[];
  businessProcessDescription = '';

  messageError = '';
  submitted = '';
  pleaseWait = false;
  changeLog = false;

  get formData() { return this.consolidationForm.controls; }

  constructor(public bsModalRef: BsModalRef, private formBuilder: FormBuilder, private bpService: BusinessProcessService, private dateTimeService: DateTimeService) { }

  ngOnInit() {
    this.itemSaved = new Subject();

    this.createForm();
    this.messageError = '';

    this.businessProcessDescription = `${this.objMessage} (Id: ${this.objId})`;
    this.bpService.getBusinessProcessChangeLogEntries(this.objId).subscribe(result => {
      this.consolidationEntries = result;
    }, error1 => {
      let err = error1;
      if (error1.indexOf('401') !== -1) {
        err = 'Erro: Sessão expirada.';
      }
      this.messageError = err;
      console.error(error1);
    });
  }

  onSave() {
    this.messageError = '';
    this.submitted = '';
    this.pleaseWait = true;
    const consolidationData = this.consolidationForm.getRawValue();

    this.bpService.businessProcessActions(this.objId, 'Consolidate', consolidationData.txtChangeLog).pipe(take(1))
      .subscribe( () => {
        this.pleaseWait = false;
        this.submitClick = true;
        this.submitted = 'Consolidação realizada com sucesso!';
        this.itemSaved.next(true);

        setTimeout(() => {
          this.submitted = '';
          this.submitClick = false;
          this.bsModalRef.hide();
          this.ngOnInit();
        }, 2000);
      }, error1 => {
        this.pleaseWait = false;
        let err = error1;
        if (error1.indexOf('401') !== -1) {
          err = 'Erro: Sessão expirada.';
        }
        this.messageError = err;
        console.error(error1);
      });
  }

  onClose() {
    this.itemSaved.next(false);
    this.bsModalRef.hide();
  }

  createForm() {
    this.consolidationForm = this.formBuilder.group({
      businessProcessName: '',
      businessProcessId: 0,
      chkAlert: [false, Validators.requiredTrue],
      txtChangeLog: ['', Validators.maxLength(500)]
    });
  }

  enableChangeLog(enabled: boolean) {
    this.messageError = '';
    if (enabled) {
      this.bpService.hasBlockItems(this.objId).subscribe(isBlock => {
        if (!isBlock) {
          this.changeLog = true;
        } else {
          this.messageError = 'Há elementos bloqueados para outros usuários.';
          this.changeLog = false;
          this.checkUnlockRights();
        }
      }, error1 => {
        let err = error1;
        if (error1.indexOf('401') !== -1) {
          err = 'Erro: Sessão expirada.';
        }
        this.messageError = err;
        console.error(error1);
      });
    } else {
      this.changeLog = false;
    }
  }

  checkUnlockRights() {
    this.bpService.checkRights(536870912).subscribe(result => {
      let messageVerb = '';
      if (result.length > 0) {
        messageVerb = 'gerenciar';
      } else {
        messageVerb = 'visualizar';
      }
      this.messageError += `<br> Clique <a class="aLinkModal" href="/manageLockedElements/${this.objId}">aqui</a> para ${messageVerb} os itens bloqueados.`;
    });
  }

}
